const TRACK_DECHETS_API = `${__configuration.apiUrl}/massia/track-dechets`;
export default class RegistresService {
	constructor($http) {
		this.$http = $http;
		this.apiResult = null;
	}

	/*--------------------------------------TRACK DECHETS TEXS--------------------------------------*/
	async getEntrants(idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null, dapFiltering = 0) {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/entrants`, {
			params: {
				idSociete: JSON.stringify(idSociete),
				dateDebut: JSON.stringify(dateDebut),
				dateFin: JSON.stringify(dateFin),
				idSiteCom: JSON.stringify(idSiteCom || 0),
				idNomenclatures: JSON.stringify(idNomenclatures || []),
				dapFiltering: JSON.stringify(dapFiltering || 0)
			}
		});

		if (res && res.data && res.data.content && res.data.content.length > 0) {
			return res;
		} else {
			return false;
		}
	}

	async printEntrants(typeRegistre, idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null, dapFiltering = 0) {
		const res = await this.$http.post(`${TRACK_DECHETS_API}/entrants/print`, idNomenclatures, {
			params: {
				typeRegistre: typeRegistre,
				idSociete: idSociete,
				dateDebut: dateDebut,
				dateFin: dateFin,
				idSiteCom: idSiteCom,
				dapFiltering: dapFiltering
			},
			responseType: 'arraybuffer'
		});

		return res;
	}

	async getSortants(idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null, dapFiltering = 0) {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/sortants`, {
			params: {
				idSociete: JSON.stringify(idSociete),
				dateDebut: JSON.stringify(dateDebut),
				dateFin: JSON.stringify(dateFin),
				idSiteCom: JSON.stringify(idSiteCom || 0),
				idNomenclatures: JSON.stringify(idNomenclatures || []),
				dapFiltering: JSON.stringify(dapFiltering || 0)
			}
		});

		if (res && res.data && res.data.content && res.data.content.length > 0) {
			return res;
		} else {
			return false;
		}
	}

	async printSortants(typeRegistre, idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null, dapFiltering = 0) {
		const res = await this.$http.post(`${TRACK_DECHETS_API}/sortants/print`, idNomenclatures, {
			params: {
				typeRegistre: typeRegistre,
				idSociete: idSociete,
				dateDebut: dateDebut,
				dateFin: dateFin,
				idSiteCom: idSiteCom,
				dapFiltering: dapFiltering
			},
			responseType: 'arraybuffer'
		});

		return res;
	}

	async verifyDapGeoLoc(idSociete, dateDebut, dateFin, idSiteCom = null, idNomenclatures = null, doApply = false) {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/texs/verification-dap-geo`, {
			params: {
				idSociete: JSON.stringify(idSociete),
				dateDebut: JSON.stringify(dateDebut),
				dateFin: JSON.stringify(dateFin),
				idSiteCom: JSON.stringify(idSiteCom || 0),
				idNomenclatures: JSON.stringify(idNomenclatures || []),
				doApply: JSON.stringify(doApply)
			}
		});

		return res;
	}

	/*--------------------------------------TRACK DECHETS COMMON--------------------------------------*/
	async getClients() {
		const siteUrl = `${__configuration.apiUrl}/massia/sites-clients/headers`;
		const res = await this.$http.get(siteUrl);
		return res.data;
	}

	async getSocietes() {
		const url = `${__configuration.apiUrl}/massia/societes-commerciales/header`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getSitesBySocieteId(idSociete) {
		const url = `${__configuration.apiUrl}/massia/sites-commerciaux/header/${idSociete}`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getAllEcoOrganismes() {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/eco-organisme-inertes`);
		if (res.data.length > 0) {
			return res.data
				.map((eo) => ({
					id: eo.societe.id,
					libelle: eo.societe.libelle,
					code: eo.societe.code
				})) // on distinct sur l'id
				.filter((eo, index, array) => array.findIndex((item) => item.id === eo.id) === index);
		}
	}

	async getNomenclatures() {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/nomenclatures`, {});
		return res;
	}

	async getNomenclaturesAutorisee(typeRegistre) {
		const res = await this.$http.get(`${TRACK_DECHETS_API}/nomenclatures-allowed/${typeRegistre}`, {});
		return res;
	}
}
RegistresService.$inject = ['$http'];
